import React, { useState } from "react";
import { Dialog } from "@mui/material";

import AButton from "../../common/form-fields-mui/AButton";
import AAutoComplete from "../../common/form-fields-mui/AAutoComplete";

const TIME_RANGE_OPTIONS = [
  { label: "1hr", value: 60 },
  { label: "1hr 15mins", value: 75 },
  { label: "1hr 30mins", value: 90 },
  { label: "1hr 45mins", value: 105 },
  { label: "2hrs", value: 120 },
];

const CopyLecturesDialog = ({
  copyDialog,
  setCopyDialog,
  handleCopyLectures,
}) => {
  const [formState, setFormState] = useState({ from: "", to: "" });

  const formHandler = (name, value) => {
    setFormState({ ...formState, [name]: value });
  };

  const handleConfirm = () => {
    handleCopyLectures({
      from: formState.from,
      to: formState.to,
    });

    closeDialog();
  };

  const closeDialog = () => {
    setCopyDialog({ isOpen: false, data: null });
  };

  return (
    <Dialog
      aria-label="Copy lectures"
      open={copyDialog.isOpen}
      PaperProps={{
        sx: {
          minWidth: "300px",
          borderRadius: "12px",
          padding: "20px",
        },
      }}
    >
      <div
        // style={titleStyles}
        className="d-flex justify-content-between align-items-center mb-3"
      >
        <h3 className="mb-0 text-bold">Copy Lectures</h3>
      </div>

      <section>
        <AAutoComplete
          label="Copy From Time Range"
          // height={inputHeight}
          // placeholder="Select"
          items={TIME_RANGE_OPTIONS}
          currentValue={formState.from}
          isShowCount={false}
          isMulti={false}
          handleChange={(value) => {
            formHandler("from", value);
          }}
        />

        <AAutoComplete
          label="Copy To Time Range"
          // height={inputHeight}
          // placeholder="Select"
          items={TIME_RANGE_OPTIONS.filter(
            (item) => item.value !== formState.from?.value
          )}
          currentValue={formState.to}
          isShowCount={false}
          isMulti={false}
          handleChange={(value) => {
            formHandler("to", value);
          }}
          isDisabled={!formState.from?.value}
        />
      </section>

      <footer className="mt-4 ml-auto">
        <a onClick={closeDialog}>Cancel</a>

        <AButton
          variant="primary_filled"
          size="sm"
          onClick={handleConfirm}
          disabled={!formState.from?.value || !formState.to?.value}
        >
          Copy Lectures
        </AButton>
      </footer>
    </Dialog>
  );
};

export default CopyLecturesDialog;
